class @App.Components.LoadingIndicator
  ## For all options, see: http://fgnass.github.io/spin.js/
  constructor: (options = {}) ->
    default_options =
      container: 'body'
      lines: 11
      length: 11
      width: 4
      radius: 12
      corners: 1
      shadow: false
      hwaccel: true
      trail: 85
      speed: 1.5
      color: '#666'
      onShow: $.noop
      onHide: $.noop

    @options = $.extend default_options, options
    @

  show: ->
    $(@options.container).spin(@options)
    @options.onShow()

  hide: ->
    $(@options.container).spin(false)
    @options.onHide()
